import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import IntroSectionAdminCloud from '../../components/AdminCloud/IntroSectionAdminCloud/IntroSectionAdminCloud';
import ServicesCardsPrivateCloud from '../../components/PrivateCloud/ServicesCardsPrivateCloud/ServicesCardsPrivateCloud';
import ExpertiseSectionAdminCloud from '../../components/AdminCloud/ExpertiseSectionAdminCloud/ExpertiseSectionAdminCloud'
import PricingPrivateCloud from '../../components/PrivateCloud/PricingPrivateCloud/PricingPrivateCloud';
import ParallaxComponent from '../../components/Common/ParallaxBackground/ParallaxComponent';
import adminCloudParallaxText from  '../../components/Common/ParallaxBackground/adminCloudParallaxText';
import Navbar from '../../components/Common/Navbar/Navbar'
import ParallaxIMG0 from './../../assets/images/itmonkeys-cyber-img-p0.png';
import ParallaxIMG1 from './../../assets/images/itmonkeys-cyber-img-p1.png';
import ParallaxIMG2 from './../../assets/images/itmonkeys-cyber-img-p2.png';
import Newsletter from '../../components/Common/Newsletter/Newsletter';
import ServiceList from '../../components/AdminCloud/ServicesSliderAdminCloud/ServicesSliderAdminCloud';
import ExpertiseSection from '../../components/AdminCloud/ExpertiseSectionAdminCloud/ExpertiseSectionAdminCloud';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData2 from '../../components/Common/IntroSectionBottom/introSectionData2';
import useSectionRefs from '../../hooks/useSectionRefs';
import BenefitsAdminCloud from '../../components/AdminCloud/ServicesSliderAdminCloud/BenefitsAdminCloud';
import { contactLinkData } from '../../data/contactLinkData';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import TimelineAdminCloud from '../../components/AdminCloud/Timeline/TimelineAdminCloud';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';
import HorizontalSlider from '../../components/Common/HorizontalSlider';

const VdiUserCase: React.FC = () => {
    const { t } = useTranslation();
    const sectionRefs = useSectionRefs();
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  
    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };
  
    const handleCloseContactModal = () => {
      setIsContactModalOpen(false);
    };

    const horizontalSliderSections = [
      {
        id: 'azure-basics',
        title: t('navbar.academy.azureFundamentals.section1.title', 'Fondamentaux Azure'),
        content: t('navbar.academy.azureFundamentals.section1.content', 'Découvrez les concepts de base du cloud Azure, son architecture et ses services principaux.'),
        bgColor: 'tw-bg-blue-900/80',
      },
      {
        id: 'azure-services',
        title: t('navbar.academy.azureFundamentals.section2.title', 'Services Azure'),
        content: t('navbar.academy.azureFundamentals.section2.content', 'Explorez les différents services proposés par Azure : calcul, stockage, réseau, et sécurité.'),
        bgColor: 'tw-bg-blue-800/80',
      },
      {
        id: 'azure-security',
        title: t('navbar.academy.azureFundamentals.section3.title', 'Sécurité et Conformité'),
        content: t('navbar.academy.azureFundamentals.section3.content', 'Apprenez à protéger vos ressources cloud et à respecter les normes de conformité.'),
        bgColor: 'tw-bg-blue-700/80',
      },
      {
        id: 'azure-pricing',
        title: t('navbar.academy.azureFundamentals.section4.title', 'Tarification et Support'),
        content: t('navbar.academy.azureFundamentals.section4.content', 'Comprenez les modèles de tarification Azure et les options de support disponibles.'),
        bgColor: 'tw-bg-blue-600/80',
      },
    ];

  return (
    <div>
      <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header 
            title={t('adminCloud.header.title', 'Services Managés Azure')} 
            subtitle={t('adminCloud.header.subtitle', 'Déléguez l\'administration de vos systèmes cloud.')} 
          />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
      <IntroSectionAdminCloud />
      <HorizontalSlider
                  initialSlide={0}
                  onSlideChange={(index) => console.log(`Slide changed to: ${index}`)}
                  className="tw-w-full"
                >
                  {horizontalSliderSections.map((section) => (
                    <div 
                      key={section.id} 
                      className={`${section.bgColor} tw-w-full tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-white tw-p-8`}
                    >
                      <div className="tw-max-w-4xl tw-mx-auto tw-text-center">
                        <h2 className="tw-text-4xl tw-font-bold tw-mb-6">{section.title}</h2>
                        <p className="tw-text-xl">{section.content}</p>
                        <div className="tw-mt-12 tw-flex tw-justify-center">
                          <button 
                            className="tw-bg-white tw-text-blue-900 tw-font-bold tw-py-3 tw-px-6 tw-rounded-full tw-shadow-lg hover:tw-bg-blue-50 tw-transition-colors"
                            onClick={handleOpenContactModal}
                          >
                            {t('common.learnMore', 'En savoir plus')}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </HorizontalSlider>
      </section>
      <div className="gradient-bg">
      <section id="start2" className="section dark" ref={sectionRefs.start2}>

          </section>
          <div className="gradient-bg">
            <section
              id="expertise"
              className="section dark"
              ref={sectionRefs.expertise}
            >
        <GridPatternCard>
      <GridPatternCardBody>
        <div className="tw-h-[5em]">
        </div>
      </GridPatternCardBody>
    </GridPatternCard>
        </section>
      </div>
      <section id="cloud" className="section light" ref={sectionRefs.cloud}>
      </section>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
      <ContactLinkSection pageKey="adminCloud" />
        <Footer />
      </section>
    </div>
    </div> 
    </div>
  );
};

export default VdiUserCase;
